module.exports = __webpack_public_path__ + "img/cca-php-level-1.3c7f2d2d.png";